import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledTileLiveStatusTitle = styled.div`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => {
    return css`
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      font-size: 12px;
      line-height: 1;
      color: ${brand_55};
    `
  }}
`

const StyledLiveDot = styled.div`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => {
    return css`
      width: 0.6em;
      height: 0.6em;
      border-radius: 50%;
      background-color: ${brand_55};
      display: inline-block;
      line-height: 0;
      margin-right: 4px;
      margin-bottom: 1px;
    `
  }}
  opacity: 1;
  animation: liveFadeInOut 1.5s ease-in-out 0s infinite alternate-reverse;
  @keyframes liveFadeInOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

const TileLiveStatusTitle: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return (
    <StyledTileLiveStatusTitle>
      <StyledLiveDot />
      {children}
    </StyledTileLiveStatusTitle>
  )
}

export default TileLiveStatusTitle
